import type { MRT_ColumnDef } from "mantine-react-table-open";
import { sortBackendDates } from "../../../../../utils/dates/sortBackendDates";
import type { Contract } from "../../../DeliveryOverview.types";

export function getEndColumn(
  contracts: Array<Contract>
): MRT_ColumnDef<Contract> {
  const usedEnds = contracts
    .map((contract) => contract.valid_until)
    .filter((valid_until) => !!valid_until)
    .sort((endA, endB) =>
      sortBackendDates(endA || undefined, endB || undefined)
    ) as Array<string>;
  const usedEndsSet = Array.from<string>(new Set(usedEnds));
  const uniqueUsedEnds = Array.from(usedEndsSet);

  return {
    accessorKey: "valid_until",
    accessorFn: (row) => row.valid_until,
    header: "Gültig bis",
    size: 140,
    sortingFn: (rowA, rowB) =>
      sortBackendDates(
        rowA.original.valid_until ?? undefined,
        rowB.original.valid_until ?? undefined
      ),
    filterVariant: "multi-select",
    mantineFilterMultiSelectProps: {
      data: uniqueUsedEnds
    }
  };
}
